<template>
  <div class="section">
    <div class="section-left">
      <el-row :gutter="10">
        <el-col v-for="(item, idx) in items" :key="idx" :span="item.col">
          <template v-if="item.prop">
            <component :is="item.component" :myprop="item.prop"></component>
          </template>
          <template v-if="!item.prop">
            <component :is="item.component"></component>
          </template>
        </el-col>
      </el-row>
    </div>
    <div class="section-right">
      <el-col v-for="(item, idx) in right" :key="idx" :span="item.col">
        <component :is="item.component"></component>
      </el-col>
    </div>
    <div class="no-data" v-if="showNull">
      <svg-icon icon-class="NoWork" class="iconStyle"></svg-icon>
    </div>
    <!-- //系统改造弹窗注释 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="tipDialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="ft16" style="text-indent: 2em; line-height: 24px">
        {{ tipText1 }}
      </div>
      <div class="ft16" style="text-indent: 2em; line-height: 24px">
        {{ tipText2 }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tipDialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import voteBallot from '@/components/indexnew/voteBallot'; //投票表决 一
import voteByBallot from '@/components/indexnew/voteByBallot'; //投票表决  二
import mywork from '@/components/indexnew/mywork'; //我的工作 一
import myworkThree from '@/components/indexnew/myworkThree'; //我的工作 三
import myworktwo from '@/components/indexnew/myworktwo'; //我的工作 二
import complaintCount from '@/components/indexnew/complaintCount'; //投诉统计
import complaintMonth from '@/components/indexnew/complaintMonth'; //本月投诉统计
import safeProduction from '@/components/indexnew/safeProduction'; //安全生产管理
import workStatistics from '@/components/indexnew/workStatistics'; //工作情况统计
import housingInfo from '@/components/indexnew/housingInfo'; //小区信息  一
import eareaInfo from '@/components/indexnew/eareaInfo'; //小区信息  二
import IntegratedQuery from '@/components/indexnew/IntegratedQuery'; //综合查询
import eaAreaSurvey from '@/components/indexnew/eaAreaSurvey'; //物业区域概况
import satisfaction from '@/components/indexnew/satisfaction'; //满意度调查
import inspectionEvaluation from '@/components/indexnew/inspectionEvaluation'; //检查考评
import closingEfficiency from '@/components/indexnew/closingEfficiency'; //办结效率
import VoteWhole from '@/components/indexnew/VoteWhole'; //全区投票表决
import EnterpriseStatistics from '@/components/indexnew/EnterpriseStatistics'; //企业诚信统计
import VotingWholeCity from '@/components/indexnew/VotingWholeCity'; //全区投票表决统计
import projectCardList from '@/components/indexnew/projectCardList'; //建设单位项目列表

//8.10后更新的
import eaAreaSurveyTemporary from '@/components/indexnew/eaAreaSurveyTemporary'; //物业区域概况临时
import SecurityCheck from '@/components/indexnew/SecurityCheck'; //安全检查
import OwnerEvaluation from '@/components/indexnew/OwnerEvaluation'; //业主评价
import aloneEstateInformation from '@/components/indexnew/aloneEstateInformation'; //安全生产检查
import fivePropertyServe from '@/components/indexnew/fivePropertyServe'; //物业服务企业前五
import myworkTemporary from '@/components/indexnew/myworkTemporary'; //我的工作   高度调整了的  260  适配市，区领导中业主评价概况
import uploadReport from '@/components/indexnew/uploadReport'; //上传报表

///右边的
import quickly from '@/components/indexnew/quickly'; //快捷方式
import knowledgeBase from '@/components/indexnew/knowledgeBase'; //行业知识库
import newsFeed from '@/components/indexnew/newsFeed'; //最新动态
import notice from '@/components/indexnew/notice'; //通知公告
import earlyWarn from '@/components/indexnew/earlyWarn'; //预警管理
import cellInfo from '@/components/indexnew/cellInfo'; //小区信息  三

//市局领导临时新增 propertyCommittee
import leaderEaAreaSurveyTemporary from '@/components/indexnew/leadershipAdd/eaAreaSurveyTemporary'; //物业区域概况临时
import complaintsTotal from '@/components/indexnew/leadershipAdd/complaintsTotal'; //投诉
import companyAndCommunity from '@/components/indexnew/leadershipAdd/companyAndCommunity';
import propertyCommittee from '@/components/indexnew/leadershipAdd/propertyCommittee';
import amountCollect from '@/components/indexnew/leadershipAdd/amountCollect';
import leaderClosingEfficiency from '@/components/indexnew/leadershipAdd/closingEfficiency'; //办结效率
import complaints from '@/components/indexnew/leadershipAdd/complaints'; //办结效率
import repair from '@/components/indexnew/leadershipAdd/repair'; //办结效率
import noticeMsg from '@/components/indexnew/noticeMsg'; //消息管理
import enterpriseProfile from '@/components/indexnew/enterpriseProfile'; //企业概况

import { mapState } from 'vuex';
import { identityEnum } from '@/enum/identityEnum';
import { SysConfigServiceSvr } from '@/service/SysConfigMge/SysConfigServiceSvr';
import { HelpControllerSvr } from '@/service/HelpControllerSvr.js';
import pdf from 'vue-pdf';
import { previewPdf } from '@/utils/downLoadPdf';
import { baseUrl } from '@/assets/js/division';

export default {
  name: 'index',
  components: {
    OwnerEvaluation,
    workStatistics,
    notice,
    cellInfo, //小区信息
    mywork,
    SecurityCheck,
    uploadReport,
    voteBallot,
    voteByBallot,
    earlyWarn,
    quickly,
    aloneEstateInformation,
    knowledgeBase,
    newsFeed,
    eaAreaSurvey,
    myworkThree,
    myworktwo,
    complaintCount,
    complaintMonth,
    safeProduction,
    housingInfo,
    eareaInfo,
    IntegratedQuery,
    satisfaction,
    inspectionEvaluation,
    closingEfficiency,
    VoteWhole,
    EnterpriseStatistics,
    VotingWholeCity,
    fivePropertyServe,
    myworkTemporary, //市局领导新增
    companyAndCommunity, //市局领导新增
    propertyCommittee, //市局领导新增
    leaderClosingEfficiency, //市局领导新增
    amountCollect, //市局领导新增
    repair, //市局领导新增
    complaints, //市局领导新增
    eaAreaSurveyTemporary, //市局领导新增
    complaintsTotal, //市局领导新增
    noticeMsg,
    enterpriseProfile,
    pdf,
    projectCardList,
  },
  props: {},
  data() {
    return {
      src: '',
      showDialog: false,
      items: [],
      right: [],
      showNull: false,
      data: '',
      identityEnum: new identityEnum(),
      helpControllerSvr: new HelpControllerSvr(),
      show1: true,
      loading: false,
      getSvrMenus: true, //是否通过请求获取首页配置
      helpList: [],
      baseURL: baseUrl(),
      //系统改造弹窗注释
      tipDialogVisible:
        JSON.parse(sessionStorage.getItem('tipDialogVisible')) === 'false'
          ? true
          : false,
      tipText1:
        '因系统升级，“微信决策管理”模块已迁移至【深圳市物业管理信息平台】，点击右侧【快捷入口】-【微信决策管理】即可进入。给各位造成的不便，敬请谅解！',
      tipText2: '如有疑问可咨询客服热线：0755-82794696、0755-82790596。',
    };
  },
  watch: {},
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  created() {
    //系统改造弹窗注释
    sessionStorage.setItem('tipDialogVisible', JSON.stringify('true'));
    let status = this.userInfo.UserParam.UserSigns
      ? this.identityEnum[this.userInfo.UserParam.UserSigns.split(',')[0]]
      : '';
    if (this.getSvrMenus) {
      new SysConfigServiceSvr()
        .getUserMenus(this.token)
        .then((res) => {
          if (res) {
            this.items = res.left;
            for (let item of this.items) {
              item.col = parseInt(item.col);
            }
            this.right = res.right;
            for (let item of this.right) {
              item.col = parseInt(item.col);
            }
            if (this.items.length === 0 && this.right.length === 0) {
              this.showNull = true;
            }
          } else this.showNull = true;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
          this.showNull = true;
        });
    } else {
      switch (status) {
        case '物业市局领导':
          this.items = [
            { component: myworkTemporary, col: 12 },
            { component: companyAndCommunity, col: 12 },
            { component: propertyCommittee, col: 12 },
            { component: leaderClosingEfficiency, col: 12 },
            { component: noticeMsg, col: 12 },
            { component: amountCollect, col: 8 },
            { component: repair, col: 8 },
            { component: complaints, col: 8 },
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: eaAreaSurveyTemporary, col: 24, prop: true },
            { component: complaintsTotal, col: 24 },
            { component: notice, col: 24 },
          ];
          break;
        case '物业市局部门领导':
          this.items = [
            // { component: eaAreaSurvey, col: 24, prop: true },
            { component: myworkTemporary, col: 10 },
            { component: OwnerEvaluation, col: 14 },
            { component: SecurityCheck, col: 24 },
            { component: uploadReport, col: 12 },
            { component: noticeMsg, col: 12 },
            // { component: VoteWhole, col: 12 },
            // { component: inspectionEvaluation, col: 12 }
            // { component: VotingWholeCity, col: 12 },
            // { component: satisfaction, col: 12 },
            // { component: EnterpriseStatistics, col: 12 }
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: earlyWarn, col: 24 },
            //{ component: newsFeed, col: 24 }
            // { component: knowledgeBase, col: 24 }
          ];
          break;
        case '物业市局工作人员':
          this.items = [
            // { component: eaAreaSurvey, col: 24, prop: true },
            { component: myworkTemporary, col: 10 },
            { component: OwnerEvaluation, col: 14 },
            { component: SecurityCheck, col: 24 },
            { component: noticeMsg, col: 12 },
            { component: uploadReport, col: 12 },
          ];
          this.right = [{ component: quickly, col: 24 }];
          break;
        case '物业区局部门领导':
        case '物业区局领导':
        case '物业区局工作人员':
          this.items = [
            // { component: eaAreaSurvey, col: 24, prop: true },
            { component: myworkTemporary, col: 10 },
            { component: OwnerEvaluation, col: 14 },
            { component: SecurityCheck, col: 24 },
            { component: noticeMsg, col: 12 },
            { component: uploadReport, col: 12 },
          ];
          this.right = [{ component: quickly, col: 24 }];
          break;
        case '工程人员':
          this.items = [
            // { component: mywork, col: 24 },
            // { component: safeProduction, col: 24 },

            { component: myworkTemporary, col: 12 },
            { component: safeProduction, col: 24 },
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: earlyWarn, col: 24 },
            { component: notice, col: 24 },
            { component: cellInfo, col: 24 },
            { component: knowledgeBase, col: 24 },
          ];
          break;
        case '日常管理员':
          this.items = [
            // { component: mywork, col: 24 },
            { component: myworkTemporary, col: 12 },
            { component: safeProduction, col: 24 },
            //{ component: voteByBallot, col: 12 },
            { component: complaintCount, col: 24 },
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: earlyWarn, col: 24 },
            { component: notice, col: 24 },
            { component: cellInfo, col: 24 },
            { component: knowledgeBase, col: 24 },
          ];
          break;
        case '企业人员':
          this.items = [
            // { component: mywork, col: 24 },
            { component: myworkTemporary, col: 24 },
            // { component: complaintMonth, col: 12 },
            { component: housingInfo, col: 24 },
            // { component: complaintMonth, col: 24 }
            { component: enterpriseProfile, col: 12 },
            // { component: complaintMonth, col: 24 }
          ];
          this.right = [
            { component: quickly, col: 24 },
            // { component: notice, col: 24 },
            { component: earlyWarn, col: 24 },
            { component: knowledgeBase, col: 24 },
          ];
          break;
        case '业委会':
          this.items = [
            // { component: mywork, col: 24 },
            { component: myworkTemporary, col: 10 },
            { component: fivePropertyServe, col: 14 },
            { component: safeProduction, col: 24 },
            // { component: complaintCount, col: 24 }
            // { component: EnterpriseStatistics, col: 12 },
            // { component: VotingWholeCity, col: 12 }
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: cellInfo, col: 24 },
            { component: notice, col: 24 },
            { component: knowledgeBase, col: 24 },
          ];
          break;
        case '受理员':
          this.items = [
            // { component: mywork, col: 24 },
            { component: myworkTemporary, col: 12 },
            { component: IntegratedQuery, col: 24 },
            { component: myworkThree, col: 24 },
            { component: workStatistics, col: 24 },
          ];
          this.right = [
            { component: notice, col: 24 },
            { component: newsFeed, col: 24 },
            { component: knowledgeBase, col: 24 },
          ];
          break;
        case '街道办':
          this.items = [
            { component: myworkTemporary, col: 12 },
            { component: OwnerEvaluation, col: 12 },
            { component: SecurityCheck, col: 24 },
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: eaAreaSurveyTemporary, col: 24, prop: true },
            // { component: earlyWarn, col: 24 },
            { component: notice, col: 24 },
            { component: newsFeed, col: 24 },
          ];
          break;
        case '业务领导':
          this.items = [
            { component: myworktwo, col: 12 },
            { component: closingEfficiency, col: 12 },
            { component: eaAreaSurvey, col: 24 },
            { component: satisfaction, col: 12 },
            { component: inspectionEvaluation, col: 12 },
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: earlyWarn, col: 24 },
            { component: notice, col: 24 },
            { component: newsFeed, col: 24 },
            { component: knowledgeBase, col: 24 },
          ];
          break;
        case '物业区领导':
          this.items = [
            { component: myworkTemporary, col: 12 },
            { component: OwnerEvaluation, col: 12 },
            { component: SecurityCheck, col: 24 },
          ];
          this.right = [{ component: quickly, col: 24 }];
          break;

        case '开发商':
          this.items = [
            { component: myworkTemporary, col: 12 },
            // { component: mywork, col: 24 },
            { component: eareaInfo, col: 24 },
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: notice, col: 24 },
            { component: knowledgeBase, col: 24 },
          ];
          break;
        case '系统管理员':
          this.items = [
            // { component: mywork, col: 24 },
            { component: myworkTemporary, col: 12 },
            { component: complaintMonth, col: 12 },
            { component: myworkThree, col: 24 },
            //{ component: voteByBallot, col: 12 },
            //{ component: voteBallot, col: 24 },
            { component: complaintCount, col: 24 },
            { component: safeProduction, col: 24 },
            { component: workStatistics, col: 24 },
            { component: housingInfo, col: 24 },
            { component: eareaInfo, col: 24 },
            { component: IntegratedQuery, col: 24 },
            { component: satisfaction, col: 12 },
            //{ component: VoteWhole, col: 12 },
            { component: EnterpriseStatistics, col: 12 },
            //{ component: VotingWholeCity, col: 12 },
            { component: closingEfficiency, col: 12 },
            { component: inspectionEvaluation, col: 12 },
          ];
          this.right = [
            { component: quickly, col: 24 },
            { component: notice, col: 24 },
            { component: knowledgeBase, col: 24 },
            { component: earlyWarn, col: 24 },
            { component: newsFeed, col: 24 },
            { component: cellInfo, col: 24 },
          ];
          break;
        //默认是项目经理
        default:
          this.items = [
            { component: myworktwo, col: 10 },
            { component: fivePropertyServe, col: 14 },
            { component: aloneEstateInformation, col: 10 },
            { component: complaintCount, col: 14 },
            { component: voteBallot, col: 24 },
          ];
          this.right = [
            { component: quickly, col: 24 },
            // { component: cellInfo, col: 24 },
            { component: earlyWarn, col: 24 },
            { component: notice, col: 24 },
            { component: knowledgeBase, col: 24 },
          ];
      }
    }
  },
  mounted() {
    this.loading = true;
    this.helpControllerSvr
      .getDocList(this.token)
      .then((res) => {
        this.loading = false;
        this.helpList = res;
      })
      .catch((err) => {
        this.loading = false;
        this.$message({
          type: 'error',
          message: err,
        });
      });
  },
  methods: {
    toWord(item) {
      // this.showDialog = true;
      // if (process.env.NODE_ENV === 'development') {
      //   this.src = 'http://10.1.2.18:8001/szwyweb/szwyweb/' + 'HelpControllerSvr.assx/getDocContent?docId=' + item.DocId;
      // } else if (process.env.NODE_ENV === 'production') {
      //   this.src = 'https://zjj.sz.gov.cn/szwyweb/szwyweb/;' + 'HelpControllerSvr.assx/getDocContent?docId=' + item.DocId;
      // }
      const seePdfUrl = `${
        this.baseURL
      }ImportantWeixinFaqDoc.svt/checkImportantFaq?id=${
        item.DocId
      }`;
      const loading = this.$loading({
        lock: true,
        text: '打开中，请稍后！',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      previewPdf(seePdfUrl, loading,this);
      // window.open(
      //   'https://zjj.sz.gov.cn/wxjwx/js/pdfviewer/web/viewer.html?file=https%3A%2F%2Fzjj.sz.gov.cn%2Fwxjwx%2Ffileupload%2FcommonFaq.pdf%3Fid%3D' +
      //     item.DocId
      // );
      // this.loading = true;
      // this.helpControllerSvr.getDocContent(item.DocId).then(res1 => {
      //   // this.helpControllerSvr.getDocContent('891d70e2-430d-4ca5-8b8f-ec381d90e916').then(res1 => {
      //   this.loading = false;
      //   let newPage = window.open();
      //   newPage.document.write(res1);
      // }).catch(err => {
      //   this.loading = false;
      //   this.$message({
      //     type: 'error',
      //     message: err
      //   });
      // });
    },
    // getComponents() {
    //   /**
    //    * @var requireComponents -- requireComponents保存每个文件的相对路径的集合,可通过keys()返回
    //    * @function requireComponents -- 也是个方法,传入keys()枚举出来的路径可返回组件实例
    //    */
    //   const requireComponents = require.context(
    //     '../../components/button',
    //     true,
    //     /\.vue/
    //   );
    //   // 遍历出每个组件的路径
    //   requireComponents.keys().forEach(fileName => {
    //     // 组件实例
    //     const reqCom = requireComponents(fileName);
    //     // 截取路径作为组件名
    //     const reqComName = fileName.split('/')[1];
    //     // 组件挂载
    //   });
    // }
  },
};
</script>

<style lang="scss" scoped>
.section {
  // overflow: auto;
  display: flex;
  width: 100%;

  // overflow-x: hidden;
  .draw-enter-active,
  .draw-leave-active {
    transition: all 0.5s ease;
    max-height: 100px;
  }

  .draw-enter,
  .draw-leave-to {
    height: 0;
    opacity: 0;
  }

  .drawdowm-enter-active,
  .drawdowm-leave-active {
    transition: all 0.3s ease;
    max-height: 100px;
  }

  .drawdowm-enter,
  .drawdowm-leave-to {
    height: 0;
    opacity: 0;
  }

  .right_top {
    cursor: pointer;
    max-height: 186px;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 0px;
    top: 70%;
    background: #188fffd1;
    color: #ffffff;
    overflow: hidden;
    z-index: 9999;
    position: fixed;
    padding: 5px;
    text-align: center;
    width: 45rem;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    .right_all {
      // width: 190px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left_img {
        margin-left: 2%;
      }
      .iphone_text {
        width: 320px;
        margin-left: 10px;
        margin-right: 4%;
        font-size: 1em;
      }
    }
  }

  .no-data {
    position: absolute;
    left: 48%;
    top: 30%;

    .iconStyle {
      font-size: 100px;
      padding-bottom: 20px;
    }
  }

  .section-left {
    width: calc(100% - 310px);
  }

  .boxshadow {
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }

  .section-right {
    min-width: 310px;
    width: 310px;
    margin-left: 10px;
  }

  .el-col {
    margin-bottom: 10px;

    & > div {
      box-shadow: 0 0 6px #a9a9a994;
    }
  }
  .el-col-12 {
    width: 100%;
  }
}
</style>
